import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/auth.service';
import { tap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        /* const currentUser = this.authenticationService.currentUser();
        if (currentUser && currentUser.token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${currentUser.token}`
                }
            });
        } 

        
        return next.handle(request);*/

        if (localStorage.getItem("Access-Token") && !request.headers.get("skip")) {
			request = request.clone({
				 setHeaders: {
					 Authorization: `Bearer ${localStorage.getItem("Access-Token")}`
				 }
			 });
            }
        return next.handle(request).pipe(
            tap(
                event => {
                     if (event instanceof HttpResponse) {
                        // console.log('all looks good');
                        // http response status code
                        // console.log(event.status);
                    }
                },
                error => {
                    console.error(error.status);
                    console.error(error.message);
                }
            )
        );
    }
}
